export default {
  getTotemsSelect(state){
    var res = [];
    state.totemsArray.forEach(t => {
      let aux = {
        value : t.id,
        text : t.nombre
      }

      res.push(aux);
    });
    return res;
  }
}